import { Link } from "react-router";

/** Unknown addresses inside the app: say so instead of silently landing on Today. */
export function NotFound() {
  return (
    <div className="page-head">
      <p className="label">404</p>
      <h1 className="display">
        Nothing <em>here</em>.
      </h1>
      <p className="lede">That page doesn't exist, or the link was cut short. Check the address, or go back to your desk.</p>
      <p className="spaced-top">
        <Link className="btn secondary" to="/today">
          Back to Today
        </Link>
      </p>
    </div>
  );
}
